import { useEffect, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersBarLayoutManagerFilterComponent = ({
  children,
  onQuickFilterVisibilityChange
}) => {
  const [isVisible, setIsVisible] = useState();
  const ref = useRef(null);
  const observer = useMemo(() => new IntersectionObserver(entries => {
    const newestEntry = entries[entries.length - 1];
    setIsVisible(!!(newestEntry !== null && newestEntry !== void 0 && newestEntry.isIntersecting));
  }, {
    threshold: 1
  }), []);
  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [observer, ref]);
  useEffect(() => {
    if (typeof isVisible === 'boolean') {
      onQuickFilterVisibilityChange(isVisible);
    }
  }, [isVisible, onQuickFilterVisibilityChange]);
  return /*#__PURE__*/_jsx("span", {
    ref: ref,
    children: children
  });
};
export default FiltersBarLayoutManagerFilterComponent;